import { ERROR_DIRECTORY, SUCCESS_DIRECTORY } from '@launcher/constants';
import electronService from '@services/electron/electron.service';

export async function getAllNestedWatchPaths(
  watchPaths: string[],
  includeRoot = true,
): Promise<string[]> {
  const allWatchPaths: string[] = [];

  for (const path of watchPaths) {
    if (typeof path !== 'string' || path.length < 1) {
      continue;
    }

    if (includeRoot) allWatchPaths.push(path);

    allWatchPaths.push(
      await electronService.joinPaths(path, SUCCESS_DIRECTORY), // /Success
      await electronService.joinPaths(path, ERROR_DIRECTORY), // /Error
    );
  }

  return allWatchPaths;
}
